import React from "react";
import ChatMessage from "./ChatMessage";
import { CircularProgress, Box } from "@mui/material";

const ChatWindow = ({ conversation, showLoading, chatEndRef, onFeedbackSubmit, onOptionClick }) => {
  const themeMode = window.__ASKBLAZE_THEME_MODE__ === "dark" ? "dark" : "light";
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column-reverse",
        minHeight: 0,
        bgcolor: themeMode === "dark" ? "#1A5632" : "#FFFFFF",
      }}
    >
      <Box
        sx={{
          overflowY: "auto",
          paddingX: "1rem",
        }}
      >
        {conversation.map((message, index) => (
          <ChatMessage
            key={index}
            message={message}
            index={index}
            onFeedbackSubmit={onFeedbackSubmit}
            onOptionClick={onOptionClick}
            isLastMessage={index === conversation.length - 1}
          />
        ))}
        {showLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
            <CircularProgress sx={{ color: themeMode === "dark" ? "#FFFFFF" : "#1A5632" }} />
          </Box>
        )}
        <div className={"end-ref"} ref={chatEndRef} />
      </Box>
    </Box>
  );
};

export default ChatWindow;
